import * as yup from 'yup';

export const checklistSchema = yup.object({
  plate: yup.string().required('a placa é obrigatória'),
  name: yup.string().required('o nome é obrigatório'),
  phone: yup.string().required('o telefone é obrigatório'),
});
